import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Product, ProductCategory, ProductShape, productShapes } from '../../../core/e-commerce/_models/product';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import {AuthNoticeService} from '../../../core/auth';
import {ProductsService} from '../../../core/e-commerce/_services';
import { NgxDropzoneChangeEvent, NgxDropzoneComponent } from 'ngx-dropzone';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import {InventoryService} from "../../../service/club-gigot/inventory.service";
import {InventoryProductDTO} from "../../../model/club-gigot/inventory-points/product/inventory-product.dto";
import {QueryParamsModel, QueryResultsModel} from "../../../core/_base/crud";
import {BehaviorSubject} from "rxjs";
import { AuthenticationService } from "../../../service/authentication.service";
import { BackendPermission } from "../../../model/backend-permission.enum";

@Component({
	selector: 'kt-dialog-product',
	templateUrl: './dialog-product.component.html',
	styleUrls: ['./dialog-product.component.scss']
})
export class DialogProductComponent implements OnInit {

	productDetailForm: FormGroup;
	error: boolean = false;
	categories: ProductCategory[];
	shapes: ProductShape[] = productShapes;
	principalImage: File[] = [];
	principalImagePath: string;
	@ViewChild('dropzone') dropzone: NgxDropzoneComponent;
    filteredMaterials: any;
    isLoading: boolean;
    materials = [];
    private selectedMaterialId: any;
    private existingRewardsProducts$ = new BehaviorSubject<InventoryProductDTO[]>([]);
    public _isEditMode : boolean = false;
    public isDisabled: boolean = false; 
    public onlyEditImageProduct : boolean = false;
    

    constructor(
        private _snackBar: MatSnackBar,
		private cdr: ChangeDetectorRef,
		public dialogRef: MatDialogRef<DialogProductComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: DialogData,
		private fb: FormBuilder,
        private authenticationService: AuthenticationService,
		private authNoticeService: AuthNoticeService,
		private productsService: ProductsService,
        private inventoryService: InventoryService
	) {
	}

	ngOnInit() {
        this._isEditMode = this.data.productData ? true : false;
        this.onlyEditImageProduct = this.authenticationService.hasPermission(BackendPermission.OnlyEditImageProduct);

		this.authNoticeService.setNotice(null);
		this.initProductForm();
		this.loadCategories();
        this.materialsAutocomplete();
        this.getRewardsProduct(999);  
	}

	initProductForm() {
		this.productDetailForm = this.fb.group({
			code: [{value: this.data.productData ? this.data.productData.code : null, disabled: false}, [Validators.required, this.validateCode()]],
			name: [this.data.productData ? this.data.productData.name : '', Validators.required],
			productCategoryId: [this.data.productData ? this.data.productData.productCategoryId : '', Validators.required],
			active: [this.data.productData ? this.data.productData.active : false],
            materialQuantity: [''],
			materialAutocomplete: [''],
        });

		if (this.data.productData && this.data.productData.productMaterials) {
            this.materials = [...this.data.productData.productMaterials];
        }

        if (this.data.productData) {
			this.principalImagePath = this.data.productData.imagePath;
		}

        if (this._isEditMode && this.onlyEditImageProduct)
        {
            this.productDetailForm.controls['name'].disable();
            this.productDetailForm.controls['code'].disable();
            this.productDetailForm.controls['productCategoryId'].disable();
            this.productDetailForm.controls['active'].disable(); 
            this.productDetailForm.controls['materialQuantity'].disable();
            this.productDetailForm.controls['materialAutocomplete'].disable();
            this.isDisabled = true;
        }
	}

	saveProduct() {
		const controls = this.productDetailForm.controls;
		if (this.productDetailForm.invalid && !this._isEditMode) {
			Object.keys(controls).forEach(controlName => {
					controls[controlName].markAsTouched();
				}
			);
			return;
		}

		let data = this.prepareJSON(this.productDetailForm.value);

        if (this.data.productData == null) {
			this.productsService.createProduct(data).subscribe(resp => {
					if (this.principalImage.length !== 0) {
						this.productsService.uploadImage(resp.id, this.principalImage[0], 'Principal').subscribe(
							response => {
								this.dialogRef.close(true);
								this.principalImageRemoved();
								this.cdr.detectChanges();
							},
							error => {
								this.cdr.detectChanges();
							});
					} else {
						this.dialogRef.close(true);
						this.cdr.detectChanges();
					}
				},
				error => {
                    this._snackBar.open(error.error, 'OK', {
                        duration: 5000,
                    });
				});
		} else {
			this.productsService.updateProduct(data, this.data.productData.id).subscribe(resp => {
					this.dialogRef.close(true);
				},
				error => {
                    this._snackBar.open(error.error, 'OK', {
                        duration: 5000,
                    });
				});
		}
	}

	prepareJSON(data) {
        data.productMaterials = this.materials;
        return data;
    }

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.productDetailForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	private loadCategories() {
		this.productsService.getProductCategories().subscribe(resp => {
				this.categories = resp;
			},
			error => {
				console.log(error);
			});
	}

	principalImageChanged($event: NgxDropzoneChangeEvent) {
		this.principalImage.splice(0, 1);
		this.principalImage.push(...$event.addedFiles);
		if (this.data.productData) {
			this.productsService.uploadImage(this.data.productData.id, $event.addedFiles[0], 'Principal').subscribe(
				response => {
					this.principalImageRemoved();
					this.cdr.detectChanges();
				},
				error => {
					this.cdr.detectChanges();
				});
		}
	}

	principalImageRemoved() {
		// this.principalImage = [];
		this.principalImagePath = null;
	}

    materialsAutocomplete() {
	    this.materialAutocompleteGeneric(this.productDetailForm.controls['materialAutocomplete']);
    }

    materialAutocompleteGeneric(control) {
        control
            .valueChanges
            .pipe(
                debounceTime(500),
                tap(() => this.isLoading = true),
                switchMap(value => {
                        let filter = {
                            Code: value,
                        };
                        let data = {
                            filter: filter,
                            pageNumber: 1,
                            pageSize: 20,
                            sortField: 'Id',
                            sortOrder: 'asc',
                        };
                        return this.productsService.getProductsMaterials(data);
                    }
                )
            ).subscribe((result: any) => {
            this.isLoading = false;
            this.filteredMaterials = result.items;
            this.cdr.detectChanges();
        });
    }

    materialSelected($event) {
        this.selectedMaterialId = $event.option.value.id;
        this.productDetailForm.controls['materialAutocomplete'].setValue($event.option.value.code);
    }

    materialCodeChange() {
        this.selectedMaterialId = null;
        this.productDetailForm.controls['materialAutocomplete'].setValue(null);
    }

    addMaterial() {
        let find = this.materials.find(material => material.material.code === this.productDetailForm.controls['materialAutocomplete'].value);
        if (find) {
            return;
        }

        if (this.selectedMaterialId && this.productDetailForm.controls['materialQuantity'].value) {
            let newMaterial = {
                materialId: this.selectedMaterialId,
                quantity: this.productDetailForm.controls['materialQuantity'].value,
                material: {
                    code: this.productDetailForm.controls['materialAutocomplete'].value
                }
            };
            this.materials.push(newMaterial);
        }
        if (!this.selectedMaterialId) {
            this.productDetailForm.controls['materialAutocomplete'].markAsTouched();
            this.productDetailForm.controls['materialAutocomplete'].setErrors({'required': true});
        }
        if (!this.productDetailForm.controls['materialQuantity'].value) {
            this.productDetailForm.controls['materialQuantity'].markAsTouched();
            this.productDetailForm.controls['materialQuantity'].setErrors({'required': true});
        }
    }

    deleteMaterial(selectedMaterial: any) {
        this.materials = this.materials.filter(material => material.material.code !== selectedMaterial.material.code);
    }


    /**
     * @description
     *	Obtiene los productos del programa de puntos.
     *
     * @param size
     *    La cantidad de datos a buscar
     */
    private getRewardsProduct(size: number): void{
        this.inventoryService.getProducts(new QueryParamsModel({"Name": ""}, 'asc', 'id', 1, size))
            .subscribe({
                next: (data: QueryResultsModel) => {
                    if(data.totalCount > size)
                        this.getRewardsProduct(data.totalCount)
                    else{
                        this.existingRewardsProducts$.next(data.items);
                    }

                },
                error: (err: Error) => {
                    console.log(err);
                }
            })
    }
    /**
     * @description
     *	Valida que el codigo selecionado para el producto no exista entre los productos
     *  del programa de puntos.
     */
    private validateCode(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!this._isEditMode){
                if (this.existingRewardsProducts$.value.find(p => p.code == control.value)!= undefined)
                    return {existingCode: true}
            }else{
                if (this.existingRewardsProducts$.value.find(p => p.code == control.value && !p.isGigotProduct)!= undefined)
                    return {existingCode: true}
            }
            return null
        };
    }
}

export interface DialogData {
	productData: Product;
}
